import cache from 'utils/cache'

function isSuperAdmin() {
  const userName = cache.get('device-name')
  const userId = cache.get('device-id')
  return userName === 'admin'
    || (typeof userName === 'string' && userName.toLowerCase() === 'admin')
    || userId === 1
    || userId === '1'
}

export function hasPermission(perms) {
  if (isSuperAdmin()) {
    return true
  }
  const authorizes = cache.get('device-authorizes')
  if (authorizes && authorizes.length > 0) {
    if (perms && authorizes) {
      return authorizes.includes(perms)
    }
    return false
  }
  return false
}
